export const equipment = {
  seo: {
    title: '器材租賃 | LensBank 專業攝影器材',
    description: '提供相機、鏡頭、燈光、收音、監看、穩定器等超過 1,000+ 件專業攝影器材租賃。多品牌選擇，彈性租期，專業技術支援。',
    keywords: '器材租賃,相機租借,鏡頭租賃,燈光器材,收音設備,攝影器材'
  },
  hero: {
    title: '專業器材租賃',
    subtitle: '超過 1,000+ 件專業攝影器材，滿足您的所有拍攝需求'
  },
  categories: {
    title: '器材分類',
    all: '全部',
    camera: '相機',
    lens: '鏡頭',
    lighting: '燈光',
    audio: '收音',
    monitor: '監看',
    stabilizer: '穩定器',
    grip: '腳架配件',
    accessories: '其他配件'
  },
  subcategories: {
    all: '全部',
    cinema: '電影機',
    mirrorless: '單眼',
    camcorder: '記錄攝影機',
    action: '運動攝影機',
    prime: '定焦鏡',
    zoom: '變焦鏡',
    led: 'LED 燈',
    hmi: 'HMI 燈',
    shotgun: '指向性麥克風',
    wireless: '無線麥克風',
    production: '現場監看',
    gimbal: '三軸穩定器'
  },
  filters: {
    title: '篩選條件',
    category: '分類',
    subcategory: '子分類',
    brand: '品牌',
    allBrands: '全部品牌',
    location: '可租門市',
    priceRange: '價格區間',
    availability: '可租狀態',
    available: '可租',
    unavailable: '已租出',
    all: '全部',
    reset: '重置篩選',
    results: '項結果',
    sortBy: '排序',
    sortDefault: '預設排序',
    sortPriceLow: '價格低到高',
    sortPriceHigh: '價格高到低',
    sortName: '名稱排序'
  },
  list: {
    // Escape the forward slash to avoid parsing errors in certain build tools
    perDay: '\\/天',
    perWeek: '\\/週',
    viewDetails: '查看詳情',
    addToCart: '加入預約',
    outOfStock: '已租出',
    inStock: '可租',
    dailyRate: '日租',
    available: '可用',
    selectCategory: '請選擇器材分類',
    selectCategoryDesc: '從上方分類列選擇您需要的器材類型，即可瀏覽所有可租借的器材。',
    noProducts: '此分類目前沒有器材',
    noProductsDesc: '請嘗試其他分類或篩選條件',
    deposit: '押金'
  },
  tags: {
    // Canonical machine keys only
    hot: '熱門',
    new: '新上架',
    incoming: '預計進貨',
    staff_required: '需搭人員',
    crew_only: '出班組限定',
    featured: '精選'
  },
  detail: {
    specifications: '規格資訊',
    pricing: '租金資訊',
    dailyRate: '日租',
    weeklyRate: '週租',
    monthlyRate: '月租',
    deposit: '押金',
    requirements: '租借需求',
    requirementsText: '需提供身分證件及信用卡作為擔保，公司行號需提供營業登記證。',
    notes: '注意事項',
    notesText: '租借器材請於約定時間內歸還，逾期將加收費用。器材如有損壞需照價賠償。',
    quantity: '數量',
    rentalPeriod: '租借期間',
    startDate: '取件日期',
    endDate: '還件日期',
    pickupLocation: '取件門市',
    selectLocation: '選擇門市',
    addToBooking: '加入預約車',
    bookNow: '立即預約',
    available: '可租',
    unavailable: '已租出',
    backToList: '返回列表',
    booking: '預約租借',
    days: '天',
    stock: '庫存',
    units: '台',
    totalEstimate: '預估租金',
    addToCart: '加入預約車',
    backToProducts: '返回器材列表',
    noWeeklyPrice: '無週租優惠',
    stockByLocation: '各門市庫存'
  },
  related: {
    title: '相關推薦器材',
    subtitle: '您可能也會感興趣',
    viewAll: '查看更多',
    noRelated: '暫無相關推薦'
  },
  booking: {
    title: '預約車',
    empty: '預約車是空的',
    item: '項目',
    quantity: '數量',
    period: '租期',
    price: '金額',
    total: '總計',
    remove: '移除',
    clear: '清空',
    checkout: '送出預約',
    continueBooking: '繼續選購'
  }
};
